import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getEventById, getEventInfosByEventId, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";
import axios from "axios";

import Loading from "./components/Loading";

import logoDE from "../images/logo_de.png";
import logoFR from "../images/logo_fr.png";
import banner from "../images/banner.jpg";

import imgIconProgressGrey from "../images/progress-bar/icon-progress-grey.svg";
import imgIconProgress1 from "../images/progress-bar/icon-progress1.svg";

const Home = () => {
    const [orderId, setOrderId] = useState();

    const [eventId, setEventId] = useState([]);
    const [posId, setPosId] = useState();
    const [event, setEvent] = useState({});

    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketTypes] = useState([]);
    const [moreInfo, setMoreInfo] = useState({});

    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(true);
    const [loaded, setLoaded] = useState(false);

    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");

    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);
    const [isTicketTypesUnlocked, setIsTicketTypesUnlocked] = useState(false);

    const ticketTypeEmployeeId = 819445;

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();

    let languageId = 0;

    let logo = logoDE;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            logo = logoFR;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (loaded) {
            startOrder(posId, eventId);
        }
    }, [language]); //everytime language is changed

    useEffect(() => {
        if (orderId) {
            loadEvent(eventId, orderId)
        }
    }, [orderId]); //gets called when an order is started

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);

            startOrder(res.data.posId, res.data.eventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 10,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadEvent = async (eventId, orderId) => {
        try {
            setLoading(true);

            sessionStorage.removeItem("isEmployee"); // clear isEmployee

            // Event
            const event = await getEventById(eventId);
            const infos = await getEventInfosByEventId(eventId);

            // sorting it according to the language
            const eventInfo = infos.eventInfos.find(info => info.languageId == languageId);

            // setting the eventInfo object in the info attribute of event
            const updatedEventInfo = { ...event, info: eventInfo };

            // TicketType
            const ticketTypes = await getTicketTypesByEventId(eventId);

            const updatedTicketTypes = await Promise.all(
                ticketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            // setting the values in the end
            setEvent(updatedEventInfo);
            setTicketTypes(updatedTicketTypes);
            setLoading(false);

        } catch (error) {
            console.error(error);
        }
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
        }
    }

    const deletePromotionCodeFromOrder = async (orderId, code) => {
        try {
            const response = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setLoading(true);

        const trimmedPromotionCode = promotioncode.trim();

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, trimmedPromotionCode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, trimmedPromotionCode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        sessionStorage.setItem("addedPromotion", trimmedPromotionCode);
        setPromotioncodeAdded(trimmedPromotionCode);

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        setIsTicketTypesUnlocked(true);
        setLoading(false);
    }

    const removePromotionFromOrder = async () => {
        setPromotionError("");
        setLoading(true);

        await deletePromotionCodeFromOrder(orderId, promotioncode);
        await loadEvent(eventId, orderId);

        setUnlockedTicketTypes([]);
        setIsTicketTypesUnlocked(false);
        setLoading(false);
    }

    const addTicketToBasket = async () => {
        let addTicketTypes = [];

        addTicketTypes = selectedTicketTypes.filter((stt) => stt.quantity !== "0");

        addTicketTypes = addTicketTypes.map((att) => {
            if (unlockedTicketTypes.includes(att.ticketTypeId)) {
                att.promotionCode = promotioncodeAdded;
            }

            return att;
        })

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                // gtm - addToCart
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'addToCart'
                });

                const hasEmployeeTicket = addTicketTypes.some(ticket => ticket.ticketTypeId === ticketTypeEmployeeId);
                if (hasEmployeeTicket) {
                    sessionStorage.setItem("isEmployee", "true");
                }

                navigate(`/${language}/address`);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const onSubmit = async () => {
        await addTicketToBasket();
    };

    const onTicketTypeChange = (e, ticketTypeId) => {
        const obj = {
            ticketTypeId: ticketTypeId,
            quantity: e.target.value,
        };

        const existingTicketType = selectedTicketTypes.find(
            (t) => t.ticketTypeId === ticketTypeId
        );

        if (existingTicketType) {
            existingTicketType.quantity = e.target.value;
        } else {
            selectedTicketTypes.push(obj);
        }

        // calcualate quantity and validate
        let quantity = 0;

        selectedTicketTypes.map(s => {
            quantity += s.quantity * 1;
        });

        if (quantity > 0) {
            setDisabled(false);
        } else {
            setDisabled(true);
        }
    };

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        //if (isTicketTypesUnlocked) {
        //    ticketTypesSorted = ticketTypesSorted.filter((tts) => unlockedTicketTypes.includes(tts.id));
        //}

        return (
            ticketTypes &&
            ticketTypes.length > 0 &&
            ticketTypesSorted.map((tt, index) => (
                <div key={index}>
                    {
                        (tt.availability?.status === 0) &&
                        (
                            <div className="pt-2 pb-2">

                                {/*<div className="col-md-3 col-4 text-center">*/}
                                {/*    <label>*/}
                                {/*        {tt.currency} {tt.price}.- (excl. MWST)*/}
                                {/*    </label>*/}
                                {/*</div>*/}

                                <select
                                    className="form-select form-select-tickets d-inline"
                                    onChange={(e) => onTicketTypeChange(e, tt.id)}>
                                    {Array.from(
                                        Array(
                                            tt.availability?.availableTickets + 1
                                        ),
                                        (e, i) => {
                                            return (
                                                <option key={i} value={i}>
                                                    {i}
                                                </option>
                                            );
                                        }
                                    )}
                                </select>

                                <label className="fs-6 d-inline ms-4">
                                    {tt.info?.name}
                                </label>
                                {/*{*/}
                                {/*    tt.info?.description && (*/}
                                {/*        <div className="description">*/}
                                {/*            <span onClick={() => setMoreInfo({ [tt.id]: !moreInfo[tt.id] })}>{resources.OtherInfos} <i className={"bi bi-chevron-" + (moreInfo[tt.id] ? "down" : "up")}></i></span><br></br>*/}
                                {/*            {moreInfo[tt.id] && tt.info?.description}*/}
                                {/*        </div>*/}
                                {/*    )*/}
                                {/*}*/}
                            </div>
                        )}
                </div>
            ))
        );
    };

    return (
        <>
            <div className="row">

                {/* fixed image column */}
                <div className="col-md-5 fixed-column">
                    <img className="img-fluid w-100" src={banner} alt="banner"></img>
                </div>

                {/* scrollable content column */}
                <div className="col-md-7 pt-3 ps-4 pe-4 scrollable-column">
                    <div className="d-flex justify-content-end">
                        <a href="https://www.prosenectute.ch/de.html">
                            <img className="logo" src={logo} alt="logo" href="https://www.prosenectute.ch/de.html" />
                        </a>
                    </div>

                    <div className="row mt-2">
                        <div className="col-md-12">
                            <span className="text-title d-block">{resources?.Title}</span>
                            <span className="text-subtitle d-block">{resources?.TitleDescription}</span>
                        </div>
                    </div>

                    {/* progress bar */}
                    <div className="progress-container mt-3">
                        <div className="progress-step active">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgress1} alt="Step 1" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressTickets}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step completed">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressGrey} alt=" Step 2" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressYourInformation}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressGrey} alt="Step 3" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressAdditionalInformation}</div>
                            </div>
                            <div className="line"></div>
                        </div>

                        <div className="progress-step">
                            <div>
                                <div className="image">
                                    <img src={imgIconProgressGrey} alt="Step 4" />
                                </div>
                                <div className="step-number text-wrap visible-desktop">{resources?.ProgressCheckout}</div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-12">
                            <span className="text-subtitle">{resources?.HomeChooseCategory}</span>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-md-12">
                            {!loading ? mapTicketTypes() : <Loading bgColor="#fff" color="#00726f" resources={resources} />}
                        </div>
                    </div>

                    {/* promocodes */}
                    <div className="mt-5">
                        <p className="text-subtitle mb-2">Promocode</p>
                        <p className="fs-10" dangerouslySetInnerHTML={{ __html: resources?.PromotionDescription }}></p>
                        <div className="row">
                            <div className="col-md-4 col-8 mb-3">
                                <input className="form-control" value={promotioncode} onChange={(e) => setPromotioncode(e.target.value)} />
                                {promotionError !== "" &&
                                    <span className="error">{promotionError}</span>
                                }
                            </div>
                            <div className="col-md-4">
                                <button className="btn button-custom" disabled={ promotioncode < 3} onClick={addPromotionToOrder}>{resources?.PromotionRedeem}</button>
                                {/*<button className="btn button-custom d-block" onClick={removePromotionFromOrder}>{resources?.PromotionRemove}</button>*/}
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-8 text-end">
                            <button className="btn button-custom" disabled={disabled} onClick={() => onSubmit()}>{resources?.Next}</button>
                        </div>
                    </div>

                    <p className="mt-4">
                        <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                    </p>
                </div>
            </div>
        </>
    )
}

export default Home